import React, { FC } from 'react'
import styles from 'styles/components/form.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { FlexRow } from 'components/Flex'
import { ArrowButton } from 'components/Button'

type Props = {
  name: string
  imageUrl: string
  index?: number
  rearrange?: (index: number, direction: 'prev' | 'next') => void
  totalLength?: number
}

const DndBreadItem: FC<Props> = (props) => {
  const { name, imageUrl, index, rearrange, totalLength } = props

  return (
    <>
      <div className={styles.image__list__item__wrapper}>
        <div className={styles.image__list__item__box__product}>
          <img className={styles.image__list__item__content} src={imageUrl} />
        </div>
        <Spacer size={4} />
        <p className={styles.image__list__item__name}>{name}</p>
        <Spacer size={4} />
      </div>
      <div className={styles.image__list__item__wrapper}>
        <FlexRow justifyContent={'center'}>
          <ArrowButton
            disabled={index === 0}
            direction={'prev'}
            onClick={
              typeof index === 'undefined' || typeof rearrange === 'undefined' || index === 0
                ? () => null
                : () => rearrange(index, 'prev')
            }
          />
          <Spacer size={20} axis={'horizontal'} />
          <span className={`${text.color_blue_main} ${text.font_bold}`}>移動する</span>
          <Spacer size={20} axis={'horizontal'} />
          <ArrowButton
            disabled={typeof index === 'undefined' || typeof totalLength === 'undefined' || index === totalLength - 1}
            direction={'next'}
            onClick={
              typeof index === 'undefined' ||
              typeof totalLength === 'undefined' ||
              typeof rearrange === 'undefined' ||
              index === totalLength - 1
                ? () => null
                : () => rearrange(index, 'next')
            }
          />
        </FlexRow>
        <Spacer size={20} />
      </div>
    </>
  )
}

export default DndBreadItem
